import { render, staticRenderFns } from "./SGPModalImagemComponent.vue?vue&type=template&id=f3878f76"
import script from "./SGPModalImagemComponent.vue?vue&type=script&lang=js"
export * from "./SGPModalImagemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports